import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiRequest } from '../../services/apiService';
import { Comodidade } from '../../data/Comodidades';
import { ListaPaginada } from '../../data/ListaPaginada';
import Pagination from '../../componets/Pagination';
import ConfirmationModal from '../../componets/ConfirmationModal';

function Comodidades() {
  const [data, setData] = useState<ListaPaginada<Comodidade> | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [comodidadeToDelete, setComodidadeToDelete] = useState<number | null>(null);
  const itemsPerPage = 10; // Itens por página

  const fetchComodidades = async (page: number) => {
    setLoading(true);
    try {
      const endpoint = `/comodidades?pagina=${page}&tamanhoPagina=${itemsPerPage}`;
      const responseData = await apiRequest<ListaPaginada<Comodidade>>(endpoint, 'GET', true);
      setData(responseData);
    } catch (err) {
      setError((err as Error).message || 'Erro ao carregar as comodidades.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchComodidades(currentPage);
  }, [currentPage]);

  const totalRecords = data?.totalItens ?? 0;
  const totalPages = data?.totalPaginas ?? 0;
  const currentItems = data?.itens ?? [];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleDeleteClick = (id: number) => {
    setComodidadeToDelete(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!comodidadeToDelete) return;

    setShowDeleteModal(false);
    setLoading(true);
    setError(null);

    try {
      await apiRequest(`comodidades/${comodidadeToDelete}`, 'DELETE', true);
      await fetchComodidades(currentPage); // Recarrega os dados
    } catch (err) {
      setError((err as Error).message || 'Erro ao excluir a comodidade.');
    } finally {
      setLoading(false);
      setComodidadeToDelete(null);
    }
  };

  if (loading && !data) {
    return <p>Carregando Comodidades...</p>;
  }

  if (error) {
    return <p>Erro: {error}</p>;
  }

  return (
    <div className="row">
      <div className="card">
        <div className="card-body">
          <div className="mb-3">
            <h1 className="h3 d-inline align-middle">Comodidades</h1>
          </div>
          <div className="mb-3 text-end">
            <Link to="/comodidades/novo" className="btn btn-primary"> Nova <i className="bi bi-plus"></i></Link>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th className="col-2">#</th>
                <th className="col">Nome</th>
                <th className="col-2">Ativo</th>
                <th className="col-3">Ações</th>
              </tr>
            </thead>
            <tbody>
            {currentItems.length === 0 ? (
              <tr><td colSpan={4} className="text-center">Nenhuma comodidade cadastrada.</td></tr>
            ) : (currentItems.map(comodidade => (
              <tr key={comodidade.id}>
                <td>{comodidade.id}</td>
                <td>{comodidade.nome}</td>
                <td>{comodidade.ativo ? 'Sim' : 'Não'}</td>
                <td>
                  <div className="d-flex gap-4">
                    <Link to={`/comodidades/editar/${comodidade.id}`} className="btn btn-outline-primary"><i className="align-middle bi bi-pencil-square"></i> Editar</Link>
                    <button onClick={() => handleDeleteClick(comodidade.id!)} className="btn btn-outline-danger"><i className="align-middle bi bi-trash"></i> Excluir</button>
                  </div>
                </td>
              </tr>)))}
            </tbody>
          </table>
          <Pagination currentPage={currentPage} totalPages={totalPages} totalRecords={totalRecords} onPageChange={handlePageChange} />
          <ConfirmationModal show={showDeleteModal} onClose={() => setShowDeleteModal(false)} onConfirm={confirmDelete} title="Confirmar Exclusão" body="Tem certeza que deseja excluir esta comodidade? Esta ação não pode ser desfeita." confirmText="Excluir" confirmButtonVariant="danger" />
        </div>
      </div>
    </div>
  );
}

export default Comodidades;